export const toISO = (value?: number | string | null) => {
  if (!value) return null;
  return typeof value === 'number' ? new Date(value * 1000).toISOString() : value;
};
